import { memo } from 'react';
import { Route, Switch } from 'react-router-dom';

import { WithLayout } from './layout';
import { guardIsRedirect } from '../../routes/interfaces';
import { getProfileCreationRoutes } from '../../routes/profileCreationConfig';

const ProfileCreation = () => (
  <WithLayout>
    <Switch>
      {getProfileCreationRoutes().map((route, index) =>
        guardIsRedirect(route) ? (
          <Route key={index} render={route.render} />
        ) : (
          <Route key={index} path={route.path} exact={false} render={route.render} />
        )
      )}
    </Switch>
  </WithLayout>
);

export default memo(ProfileCreation);
